import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';
import { map } from 'rxjs/operators';
import { AuthenticationService, LOCAL, StorageService } from '../../services';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationKeycloakGuard extends KeycloakAuthGuard implements CanLoad, CanActivateChild {

  constructor(
    protected override readonly router: Router, 
    protected readonly keycloak: KeycloakService, 
    protected readonly authService: AuthenticationService,
    protected readonly storageService: StorageService) {
    super(router, keycloak);
  }

  public async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree>{
    return this.canActivate(route, state);
  }

  public async canLoad(route: Route) {
    // Force the user to log in if currently unauthenticated.
    return this.keycloak.isLoggedIn().then((loggedIn) =>{
      if (!loggedIn) {
        this.keycloak.login({
          redirectUri: window.location.origin + this.router.getCurrentNavigation().extractedUrl.toString()
        });
      }
      else{
        // Get the roles required from the route.
        return this.roleValidation(route.data?.roles);
      }
    });
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {
    // Force the user to log in if currently unauthenticated.
    if (!this.authenticated) {
      await this.keycloak.login({
        redirectUri: window.location.origin + state.url
      });
    }

    // Get the roles required from the route.
    return this.roleValidation(route.data?.roles);
  }

  async roleValidation(roles: Array<any>): Promise<boolean>{
    if(!this.storageService.getItem(LOCAL.CURRENT_USER) || 
    !this.storageService.getItem(LOCAL.ROLE_USER) || 
    !this.storageService.getItem(LOCAL.RESPONSE_GROUP_USER)){
      const userRoles = await this.authService.getUserRoles().pipe(map(response => {return response})).toPromise();
      this.authService.userData(null, userRoles);
      return this.checkRoles(roles);
    }
    else{
      return this.checkRoles(roles);
    }
  }
  
  checkRoles(roles: Array<any>): boolean{
    // Allow the user to proceed if no additional roles are required to access the route.
    if (!(roles instanceof Array) || roles.length === 0) {
      return true;
    }

    // Allow the user to proceed if all the required roles are present.
    if(roles.every((role) => this.storageService.getItem(LOCAL.RESPONSE_GROUP_USER).includes(role))){
      return true;
    }
    else{
      this.router.navigate(['/home']);
      return false;
    }
  }
}
